export const Emis = [
  { name: "Velocity", value: 2, buildType: "Velocity" },
  { name: "Convergence", value: 3, buildType: "no" },
  { name: "Ideagen EHS", value: 4, buildType: "processmap" },
  { name: "Cority", value: 5, buildType: "no" },
  { name: "Marsh", value: 6, buildType: "no" },
  { name: "SBN", value: 7, buildType: "no" },
  { name: "ETQ", value: 9, buildType: "ETQ" },
  { name: "Intelex", value: 10, buildType: "intelex" },
  { name: "EHS Insight", value: 11, buildType: "ehs" },
  { name: "AIC", value: 13, buildType: "AIC" },
  { name: "Partner Demo", value: 15, buildType: "Partner Demo" },
  { name: "BSI/Entropy", value: 16, buildType: "no" },
  { name: "SafetyStratus", value: 18, buildType: "SAFETYSTR" },
  { name: "Vector", value: 24, buildType: "Vector" },
];
